import { filterOptionDefinitions, PROPERTY_DOCUMENT_TYPES } from '../propertyConfig';
import { AMENITY_CATEGORIES, amenityLabel } from '../amenitiesConfig';
import { SettingsIcon } from './IconSet';

function FilterDrawer({
  isOpen,
  onClose,
  foldedQuickFilterFields = [],
  minPrice,
  maxPrice,
  minBedrooms,
  minBathrooms,
  postedWithin,
  setMinPrice,
  setMaxPrice,
  setMinBedrooms,
  setMinBathrooms,
  setPostedWithin,
  filterState,
  filterSetters,
  filterAmenities = [],
  toggleFilterAmenity,
  showAmenityFilters,
  filterPropertyDocuments = [],
  toggleFilterPropertyDocument,
  showPropertyDocumentFilters,
  resetAllFilters,
  resultCount,
}) {
  return (
    <>
      {isOpen && (
        <button
          type="button"
          className="filter-overlay"
          onClick={onClose}
          aria-label="Close filters"
        />
      )}

      <aside className={`filter-drawer ${isOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <div>
            <p className="drawer-kicker">
              <SettingsIcon size={16} /> Search Tools
            </p>
            <h3>Advanced Filters</h3>
          </div>
          <button type="button" className="btn-link" onClick={onClose}>
            Close
          </button>
        </div>

        {/* Quick filters that didn't fit in the mobile toolbar row - see
            BrowseQuickFilters.js. Never rendered on desktop, where nothing
            ever folds (all four always fit in the visible toolbar). */}
        {foldedQuickFilterFields.length > 0 && (
          <div className="drawer-folded-filters">
            <p className="drawer-subheading">From the filter bar</p>
            <div className="drawer-grid">
              {foldedQuickFilterFields.map((field) => (
                <div key={field.key}>{field.render()}</div>
              ))}
            </div>
          </div>
        )}

        <div className="drawer-grid">
          <input
            className="ui-input"
            type="number"
            min="0"
            value={minPrice}
            onChange={(event) => setMinPrice(event.target.value)}
            placeholder="Min price"
          />
          <input
            className="ui-input"
            type="number"
            min="0"
            value={maxPrice}
            onChange={(event) => setMaxPrice(event.target.value)}
            placeholder="Max price"
          />
          <input
            className="ui-input"
            type="number"
            min="0"
            value={minBedrooms}
            onChange={(event) => setMinBedrooms(event.target.value)}
            placeholder="Min bedrooms"
          />
          <input
            className="ui-input"
            type="number"
            min="0"
            value={minBathrooms}
            onChange={(event) => setMinBathrooms(event.target.value)}
            placeholder="Min bathrooms"
          />
          <select
            className="ui-select"
            value={postedWithin}
            onChange={(event) => setPostedWithin(event.target.value)}
          >
            <option value="any">Posted anytime</option>
            <option value="today">Today</option>
            <option value="week">This week</option>
            <option value="month">This month</option>
          </select>
        </div>

        <div className="checkbox-grid">
          {filterOptionDefinitions.map(([key, label]) => (
            <label key={key}>
              <input
                type="checkbox"
                checked={filterState[key]}
                onChange={(event) => filterSetters[key](event.target.checked)}
              />
              {label}
            </label>
          ))}
        </div>

        {showAmenityFilters && (
          <div className="amenity-filter-section">
            <p className="drawer-subheading">Short-let amenities</p>
            {AMENITY_CATEGORIES.map((category) => {
              const selectedCount = category.amenities.filter((key) =>
                filterAmenities.includes(key),
              ).length;
              return (
                <details key={category.id} className="amenity-filter-category">
                  <summary>
                    <span>
                      {category.label}
                      {selectedCount > 0 && (
                        <span className="amenity-filter-count">{selectedCount}</span>
                      )}
                    </span>
                  </summary>
                  <div className="checkbox-grid">
                    {category.amenities.map((key) => (
                      <label key={key}>
                        <input
                          type="checkbox"
                          checked={filterAmenities.includes(key)}
                          onChange={() => toggleFilterAmenity(key)}
                        />
                        {amenityLabel(key)}
                      </label>
                    ))}
                  </div>
                </details>
              );
            })}
          </div>
        )}

        {showPropertyDocumentFilters && (
          <div className="amenity-filter-section">
            <p className="drawer-subheading">Property Documentation</p>
            <div className="checkbox-grid">
              {PROPERTY_DOCUMENT_TYPES.map(([key, label]) => (
                <label key={key}>
                  <input
                    type="checkbox"
                    checked={filterPropertyDocuments.includes(key)}
                    onChange={() => toggleFilterPropertyDocument(key)}
                  />
                  {label}
                </label>
              ))}
            </div>
          </div>
        )}

        <div className="drawer-actions">
          <button type="button" className="btn-link" onClick={resetAllFilters}>
            Reset all
          </button>
          <button type="button" className="btn-primary" onClick={onClose}>
            ✅ Show {resultCount} results
          </button>
        </div>
      </aside>
    </>
  );
}

export default FilterDrawer;
